import GlobalHeader from './src/main';
export default GlobalHeader;